module.exports = __webpack_public_path__ + "static/img/pl.d113da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/pl.png
// module id = y/O2
// module chunks = 53